module.exports = __webpack_public_path__ + "assets/LTangentDetailed.1760f75cdc899b4b4db49be5f13f64c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LTangentDetailed.png
// module id = 534
// module chunks = 0